const vars = {
    navbarHeight: '60px',
    footerMinHeight: '60px',
    dividerColor: '#C8C1B5',
    dangerTintSoftRgb: '255, 242, 235',
    foregroundColor: '#111111',
    backgroundColor: 'rgb(255, 254, 249)',
    backgroundColorBright: '#FBF7EE',
    backgroundColorDark: '#F1EBDD',
    backgroundColorContent: 'rgb(255, 254, 249)',
    primaryColor: '#A8D07A',
    primaryColorLight: '#F3F9EE',
    successTint: '#BEDAA0',
    successTintSoft: 'rgb(236, 253, 230)',
    warningColor: '#EFA417',
    warningColorDark: '#CC8A0A',
    warningTintSoft: 'rgb(255, 248, 220)',
    dangerTint: '#E8B8B2',
    dangerColor: '#C65E50',
    dangerColorDark: '#A84E42',
    dangerTintSoft: 'rgb(255, 242, 235)',
    accentColor: '#2F5A13',
    modalShadow: '0 16px 40px rgba(0, 0, 0, 0.33)',
};

export default vars;
